import { create } from 'zustand';

// DO NOT USE DIRECTLY

type Store = {
  screen?: string;
};

type Actions = {};

const initialState = {
  screen: undefined,
};

export const TrackingStore = create<Store & Actions>()((set, get) => ({
  ...initialState,
}));
